import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-stage-process-stepper',
	templateUrl: './stage-process-stepper.component.html',
	styleUrls: ['./stage-process-stepper.component.scss']
})
export class StageProcessStepperComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() stepper_stage: any;
	@Input() stepper_details: any;
	@Output() stepperChange = new EventEmitter<any>();

	selected_step: any = 1;

	constructor() {}

	ngOnInit(): void {
		this.selected_step = this.stepper_stage["step"];
	}

	changeStepper(data) {
		this.selected_step = data.step;
		this.stepperChange.emit(data);
	}

  getFormattedNumber(value) {
    return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
  }
}

